import axios from 'axios';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import { useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from 'src/baseUrl';
import Button from 'src/components/button';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
});

const PinVerification: React.FC<IProps> = ({}) => {
  const location = useLocation();

  const navigate = useNavigate();
  const [code, setCode] = React.useState('');
  const [pinLoading, setPinLoading] = useState(false);

  const handleChange = (code: string) => {
    setCode(code);
  };

  const accessToken = location?.state?.access_token;

  const handleKeyPress = (event: KeyboardEvent, submitForm: () => void) => {
    if (event.key === 'Enter' && code.length === 4) {
      event.preventDefault();
      submitForm(); // Submit the form when code length is 4
    }
  };

  const handleRegisterPin = async () => {
    if (pinLoading) return;
    if (code.length !== 4) {
      return;
    }
    setPinLoading(true);
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const requestData = {
        pin: code,
      };

      const response = await axios.post(
        `${BASE_URL}/employees/change/pin`,
        requestData,
        config
      );
      const data = response.data;
      setPinLoading(false);

      toastAlert('success', 'Your account has be created.');
      navigate('/login');
    } catch (err: any) {
      toastAlert(
        'error',
        err?.response?.data?.message ?? 'Something went wrong.'
      );
      setPinLoading(false);
    }
  };

  return (
    <div className="my-auto self-center">
      <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
        <div className="my-6">
          <h1 className="text-4xl font-semibold mb-5">Set Transaction Pin</h1>
          <p className="text-light-grey text-base">
            This PIN will be used for the waiter app
          </p>
          <Formik
            initialValues={{ code: '' }}
            onSubmit={handleRegisterPin}
            validateOnMount
          >
            {({ isSubmitting, isValid, submitForm }) => (
              <Form className="flex flex-col mt-6 gap-5 ">
                <OtpInput
                  value={code}
                  onChange={(newCode: string) => handleChange(newCode)}
                  numInputs={4}
                  separator={<span style={{ width: '20px' }}></span>}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  className="mt-5 ds"
                  containerStyle={{
                    justifyContent: 'space-between',
                  }}
                  inputStyle={{
                    border: '1px solid #CACFE3',
                    borderRadius: '8px',
                    width: '64px',
                    height: '64px',
                    fontSize: '15px',
                    color: '#000',
                    fontWeight: '400',
                  }}
                  focusStyle={{
                    border: '1px solid #4062FF',
                    outline: 'none',
                  }}
                />

                <Button
                  text={pinLoading ? 'Setting pin...' : 'Set Pin'}
                  type="submit"
                  variant="primary"
                  className="w-full mt-5 h-[40px]"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PinVerification);
